import { render, staticRenderFns } from "./passOnLog.vue?vue&type=template&id=16de9a23&scoped=true&"
import script from "./passOnLog.vue?vue&type=script&lang=js&"
export * from "./passOnLog.vue?vue&type=script&lang=js&"
import style0 from "./passOnLog.vue?vue&type=style&index=0&id=16de9a23&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de9a23",
  null
  
)

export default component.exports